import { createSlice } from '@reduxjs/toolkit';
import { DocumentCategoryModel } from '@/Models/_Microservices/OnlineArchive/DocumentCategoryModel';
import { asyncActions } from './asyncActions';
import { arrayUtils } from '@/Utils';

export type DocumentCategoriesDataState = {
  documentCategories: DocumentCategoryModel[];
};

const initialState: DocumentCategoriesDataState = {
  documentCategories: [],
};

const documentCategoriesDataSlice = createSlice({
  name: 'documentCategoriesData',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(asyncActions.getDocumentCategories.fulfilled, (state, action) => {
        state.documentCategories = arrayUtils.sortBy(action.payload, 'name');
      })
      .addCase(asyncActions.createDocumentCategory.fulfilled, (state, action) => {
        const result = [action.payload.documentCategory, ...state.documentCategories];
        state.documentCategories = arrayUtils.sortBy(result, 'name');
      })
      .addCase(asyncActions.updateDocumentCategory.fulfilled, (state, action) => {
        const { documentCategory } = action.payload;

        const result = state.documentCategories.map((item) =>
          item.id === documentCategory.id ? documentCategory : item,
        );

        state.documentCategories = arrayUtils.sortBy(result, 'name');
      })
      .addCase(asyncActions.deleteDocumentCategory.fulfilled, (state, action) => {
        const { categoryId, subcategoryId } = action.payload;

        if (subcategoryId == undefined) {
          state.documentCategories = state.documentCategories.filter((item) => item.id !== categoryId);
        } else {
          const parent = state.documentCategories.find((p) => p.id === categoryId);

          if (!parent) return;

          const idx = parent.documentSubcategories.findIndex((i) => i.id === subcategoryId);

          if (idx !== -1) {
            parent.documentSubcategories.splice(idx, 1);
          }
        }
      });
  },
});

export const documentCategoriesDataReducer = documentCategoriesDataSlice.reducer;
export const documentCategoriesDataActions = documentCategoriesDataSlice.actions;
export const documentCategoriesDataAsyncActions = asyncActions;
